import { render, staticRenderFns } from "./history-meal.vue?vue&type=template&id=8c5d0830&scoped=true&"
import script from "./history-meal.vue?vue&type=script&lang=ts&"
export * from "./history-meal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5d0830",
  null
  
)

export default component.exports